import { OptionalLink } from "../ReusableStyledComponents/OptionalLink";
import { AgnosticDropdownCTA, AgnosticDropdownOptionCTAProps } from "./InternalDropdownCTA";

interface DropdownOptionCTAProps extends AgnosticDropdownOptionCTAProps {
    href?: string;
    target?: string;
}

export const DropdownOptionCTA = ({ href, target, ...rest }: DropdownOptionCTAProps) => {
    return (
        <OptionalLink href={href} target={target}>
            <AgnosticDropdownCTA {...rest} />
        </OptionalLink>
    );
};
